// create customer overview controller main function
var CreateCustomerOverViewController = function ($scope, $anchorScroll, $timeout, customerModelService, $state, bootstrapParameters, $q, createCustomerLoader, $log, VehicleService) {
    //loader instance
    $scope.createCustomerLoader = createCustomerLoader;
    // vehicle details items
    $scope.vehicleDetailsItems = [
        { type: 'make', redirect: 'createcustomer.manufacturer' },
        { type: 'year', redirect: 'createcustomer.year' },
        { type: 'model', redirect: 'createcustomer.model' },
        { type: 'transmission', redirect: 'createcustomer.transmission' },
        { type: 'engine', redirect: 'createcustomer.engine' },
        { type: 'driveTrain', redirect: 'createcustomer.drivetrain' }
    ];

    // vehicle details
    $scope.vehicle = {
        make: '',
        year: '',
        model: '',
        transmission: '',
        engine: '',
        driveTrain: ''
    };
    // updateCurrentVehicleData
    //
    // @return {String} vehicle details
    //
    // @description
    // Update the vehicle details in scope
    $scope.updateCurrentVehicleData = function (changeState) {
        if (changeState) $state.go('overview');
        // vehicle details
        $scope.vehicle = {
            make: customerModelService.getCurrentVehicle().getManufacturer(),
            year: customerModelService.getCurrentVehicle().getYear(),
            model: customerModelService.getCurrentVehicle().getModel(),
            transmission: customerModelService.getCurrentVehicle().getTransmission(),
            engine: customerModelService.getCurrentVehicle().getEngine(),
            driveTrain: customerModelService.getCurrentVehicle().getDriveTrain()
        };
        //reset recalls storge;
        customerModelService.setRecallsUpdates();
    };
    //refernce to vehicle in customerModelService required to directly set
    //the odometer. It is ugly realiztion and requires rewriting
    $scope.vehicleReferece = customerModelService.getCurrentVehicle();
    $scope.odometerValueKind = $scope.vehicleReferece.getManufacturer().kilometersOrMiles;
    // getItemValue
    //
    // @param {String} name of the property of the vehilce
    //
    // @return {String} value of the required property
    //
    // @description
    // Gets the value of the vehicle details property
    $scope.getItemValue = function (valueType) {
        return $scope.vehicle[valueType] ? $scope.vehicle[valueType].name : undefined;
    };
    // continue
    //
    // @description
    // This function calls when user clicks on continue button
    // when the click triggers method will chenge the current
    // state to book appointment state
    $scope.continue = function () {
        if (!$scope.odometerForm.$valid) {
            $scope.odometerForm.$setDirty();
            scrollTo('odometerField');
        } else {
            vehicle = customerModelService.getCurrentVehicle();
            vehicle.odometer = $scope.odometer;
            $state.go('bookappointment');
        }
    };
    // goToState
    //
    // @param {String} state name
    //
    // @description
    // Change the current state according to passed state name
    $scope.goToState = function (stateName, params) {
        var vehicle = customerModelService.getCurrentVehicle();
        if (vehicle) {
            delete (vehicle.links);
            vehicle.setVinNumber('');
        }
        $state.go(stateName, params);
    };
    //decode vin handler
    $scope.vinDecodeHandler = function () {
        checkAutoSelectedItems();
        $scope.updateCurrentVehicleData();
    };

    //scrollTo
    //
    //@param {string} - element id
    //
    //@description
    //Scrolls current container untill element with given id will reached
    function scrollTo(elId) {
        //if use the $location.hash is call $rootScope.$evalAsync
        //and reloads the parameters of the form ($dirty set to false).
        //Timeout needed to get content height after form validation.
        $timeout(function () {
            $anchorScroll(elId);
        }, 0);
    }

    function checkAutoSelectedItems() {
        var vehicleCreationData = customerModelService.getVehicleCreationData();
        if (vehicleCreationData) {
            _.forEach($scope.vehicleDetailsItems, function (el) {
                el.autoSelected = !!_.find(_.get(vehicleCreationData, el.type + 's'), 'autoSelected');
            });
        }
    }

    //initData
    //
    //@description
    //Inits all required data
    function initData() {
        checkAutoSelectedItems();
        $scope.updateCurrentVehicleData();
        // retrieve current vehicle from the model service
        var vehicle = customerModelService.getCurrentVehicle();
        // reset current maintenance interval
        vehicle.setCurrentMaintenanceInterval();
        // get odometer value taken from Telematics 
        var telematicsOdometer = vehicle.getTelematicsOdometer();
        //set the odometer value if one is passed throught bootstrap parameters
        $scope.odometer = vehicle.odometer || parseInt(bootstrapParameters.getParameter('mileage')) || telematicsOdometer || undefined;
        //clear vin number if it is required
        $scope.vinNumber = vehicle ? vehicle.getVinNumber() : '';
    }

    //init
    //
    //@description
    //Entry point into controller business logic
    function init() {
        var vehicle = customerModelService.getCurrentVehicle();
        if (vehicle && !vehicle.links) {
            var driveTrain = vehicle.getDriveTrain();
            var loader = $q.defer();
            driveTrain.getVehicle().then(function (vehicle) {
                return VehicleService.setVehicleDetails(vehicle);
            }).then(function (vehicleModel) {
                vehicleModel.setMaintenance(vehicleModel.maintenance);
                customerModelService.setCurrentVehicle(vehicleModel);
            }).catch(function (err) {
                $log.error('Something went wrong');
                $log.error(err);
            }).finally(function () {
                initData();
                loader.resolve();
            });
            createCustomerLoader.addPromise(loader.promise);
        } else {
            initData();
        }
    }
    //start the controller
    init();
};
// create customer overview controller function injections
CreateCustomerOverViewController.$inject = ['$scope', '$anchorScroll', '$timeout', 'customerModelService', '$state', 'bootstrapParameters', '$q', 'createCustomerLoader', '$log', 'VehicleService'];

module.exports = CreateCustomerOverViewController;
